<template>
	<div id="app">
		<div>
			<app-header></app-header>
			<router-view />
			<app-footer></app-footer>
		</div>
	</div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
export default {
	name: "App",
	data() {
		return {};
	},
	components: {
		"app-header": Header,
		"app-footer": Footer,
	},
	methods: {},
};
</script>
<style>
@import "../static/css/jquery-ui.min.css";
@import "../static/css/common.css";
</style>



// WEBPACK FOOTER //
// src/App.vue